import { WorkoutsScreen } from '~/workout/components/workouts-screen/WorkoutsScreen';

export default WorkoutsScreen;
